var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "600" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v(_vm._s("add"))]),
                  _vm._v(" " + _vm._s("Detalle comsión") + "\n        ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: { xs12: "", "align-self-center": "true" }
                            },
                            [
                              _c(
                                "v-card",
                                { attrs: { elevation: "3", color: "#E8EAEA" } },
                                [
                                  _c("p", [
                                    _c("strong", [
                                      _vm._v("CITE de la comisión:")
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(this.form.cite) +
                                        "\n                  "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: { xs12: "", "align-self-center": "true" }
                            },
                            [
                              _c(
                                "v-card",
                                { attrs: { elevation: "3", color: "#E8EAEA" } },
                                [
                                  _c("strong", [
                                    _vm._v("Objetivo de la comisión:")
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v(_vm._s(this.form.objetivo))])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", "align-self-center": "true" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { elevation: "3", color: "#E8EAEA" } },
                                [
                                  _c(
                                    "p",
                                    [
                                      _c("strong", [
                                        _vm._v("Fecha salida (viaje):")
                                      ]),
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            this.form.fecha_salida
                                              .split("-")
                                              .reverse()
                                              .join("/")
                                          ) +
                                          "\n                    "
                                      ),
                                      _c("v-icon", [_vm._v("date_range")])
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", "align-self-center": "true" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { elevation: "3", color: "#E8EAEA" } },
                                [
                                  _c(
                                    "p",
                                    [
                                      _c("strong", [
                                        _vm._v("Fecha retorno (viaje):")
                                      ]),
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            this.form.fecha_retorno
                                              .split("-")
                                              .reverse()
                                              .join("/")
                                          ) +
                                          "\n                    "
                                      ),
                                      _c("v-icon", [_vm._v("date_range")])
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", "align-self-center": "true" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { elevation: "3", color: "#E8EAEA" } },
                                [
                                  _c(
                                    "p",
                                    [
                                      _c("strong", [
                                        _vm._v("Hora salida (viaje):")
                                      ]),
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(this.form.hora_salida_viaje) +
                                          "\n                    "
                                      ),
                                      _c("v-icon", [_vm._v("schedule")])
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", "align-self-center": "true" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { elevation: "3", color: "#E8EAEA" } },
                                [
                                  _c(
                                    "p",
                                    [
                                      _c("strong", [
                                        _vm._v("Hora retorno (viaje):")
                                      ]),
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(this.form.hora_retorno_viaje) +
                                          "\n                    "
                                      ),
                                      _c("v-icon", [_vm._v("schedule")])
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", "align-self-center": "true" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { elevation: "3", color: "#E8EAEA" } },
                                [
                                  _c(
                                    "p",
                                    [
                                      _c("strong", [
                                        _vm._v("Hora salida tolerancia:")
                                      ]),
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(this.form.hora_salida_tolera) +
                                          "\n                    "
                                      ),
                                      _c("v-icon", [_vm._v("schedule")])
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", "align-self-center": "true" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { elevation: "3", color: "#E8EAEA" } },
                                [
                                  _c(
                                    "p",
                                    [
                                      _c("strong", [
                                        _vm._v("Hora retorno tolerancia:")
                                      ]),
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            this.form.hora_retorno_tolera
                                          ) +
                                          "\n                    "
                                      ),
                                      _c("v-icon", [_vm._v("schedule")])
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("small", [
                        _vm._v(
                          "* El sistema otorga dos horas de tolerancia antes y despues de\n              los horarios del viaje"
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("cancel")]), _vm._v("Cerrar ")],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56c12153", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56c12153","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/comision_viaje/dialogs/VerDetalleRegistro.vue
// module id = null
// module chunks = 